const envExample = {
    name: '禹途出行',
    logo: '/images/logo.png',
    AMap: {
        key: '5ab240851fee5cd55f03b930807460fa'
    },
    isPosSwitch:false,//false不允许切换商户,true允许商户切换
}
export default envExample;
